// import { useState, useEffect } from 'react';
// import {
//   DEFAULT_USER_SITE_ID,
//   MAX_SUBJECTS_PER_USER,
// } from './Contants';
// import {
//   convertDateToDisplayFormat,
//   capitalizeFirstLetter,
//   generateSubjectId,
// } from './utils';
// import { getSitesDropdown, createSubject, getSubjects } from '../../Config/api';

// export const useDataCapture = () => {
//   const [subjects, setSubjects] = useState([]);
//   const [sites, setSites] = useState([]);
//   const [loadingSites, setLoadingSites] = useState(true);
//   const [loadingSubjects, setLoadingSubjects] = useState(true);
//   const [user, setUser] = useState(null);
//   const [userAssignedSiteId, setUserAssignedSiteId] = useState(DEFAULT_USER_SITE_ID);
//   const [showLimitModal, setShowLimitModal] = useState(false);

//   const getToken = () => localStorage.getItem('token');

//   useEffect(() => {
//     const userData = localStorage.getItem('user');
//     if (userData) {
//       const parsedUser = JSON.parse(userData);
//       setUser(parsedUser);
//       if (parsedUser.siteId) {
//         setUserAssignedSiteId(parsedUser.siteId);
//         localStorage.setItem('userAssignedSiteId', parsedUser.siteId.toString());
//       } else {
//         setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//         localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//       }
//     } else {
//       setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//       localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//     }
//   }, []);

//   const fetchSubjects = async () => {
//     try {
//       setLoadingSubjects(true);
//       const response = await getSubjects();

//       console.log('Subjects Response:', response);

//       if (response && response.success && response.data) {
//         const formattedSubjects = response.data.map((subject) => {
//           let siteId = null;
//           let studyId = null;

//           if (sites.length > 0) {
//             const matchedSite = sites.find(s =>
//               s.code === subject.site_code ||
//               s.name === subject.site_name
//             );

//             if (matchedSite) {
//               siteId = matchedSite.id;
//               studyId = matchedSite.studyId;
//             }
//           }

//           return {
//             siteName: subject.site_name || subject.siteName,
//             siteCode: subject.site_code || subject.siteCode,
//             siteId: siteId,
//             subjectId: subject.subject_id || subject.subjectId,
//             subjectInitials: subject.subject_initials || subject.subjectInitials,
//             dateOfEnrollment: subject.enrollment_date || subject.dateOfEnrollment,
//             screeningNumber: subject.subject_id || subject.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(subject.enrollment_status || subject.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: subject.lock_status || 'unlocked',
//             progress: subject.progress || 0,
//             studyId: studyId,
//           };
//         });

//         console.log('Formatted Subjects:', formattedSubjects);
//         setSubjects(formattedSubjects);
//       } else {
//         console.log('No subjects found or invalid response');
//         setSubjects([]);
//       }
//     } catch (error) {
//       console.error('Error fetching subjects:', error);
//       setSubjects([]);
//     } finally {
//       setLoadingSubjects(false);
//     }
//   };

//   const fetchSites = async () => {
//     try {
//       setLoadingSites(true);
//       const data = await getSitesDropdown();

//       console.log('Sites Dropdown Response:', data);

//       if (data.success) {
//         const formattedSites = data.data.map((site) => ({
//           id: site.site_id,
//           code: site.site_code,
//           name: site.site_name,
//           studyId: site.study_id,
//           userId: site.user_id,
//           enrolled: 0,
//           maxEnrollment: site.max_enrollment || 5,
//           progress: 0,
//         }));

//         console.log('Formatted Sites:', formattedSites);
//         setSites(formattedSites);
//       }
//     } catch (error) {
//       console.error('Error fetching sites:', error);
//       setSites([]);
//     } finally {
//       setLoadingSites(false);
//     }
//   };

//   useEffect(() => {
//     fetchSites();
//   }, []);

//   useEffect(() => {
//     if (sites.length > 0) {
//       fetchSubjects();
//     }
//   }, [sites.length]);

//   useEffect(() => {
//     if (sites.length > 0 && subjects.length > 0) {
//       const updatedSites = sites.map((site) => ({
//         ...site,
//         enrolled: subjects.filter((s) => s.siteId === site.id).length,
//         progress: Math.round(
//           (subjects.filter((s) => s.siteId === site.id).length / site.maxEnrollment) * 100
//         ),
//       }));
//       setSites(updatedSites);
//     }
//   }, [subjects]);

//   const userRoleName = user?.role?.roleName;

//   const canWrite = [
//     'CRO Administrator',
//     'Sponsor',
//     'Principal Investigator',
//     'Co-ordinator member',
//   ].includes(userRoleName);

//   const canDataCapture = [
//     'Principal Investigator',
//     'Co-ordinator member',
//   ].includes(userRoleName);

//   const userSubjectsCount = subjects.length;
//   const userSite = sites.find((s) => s.id === userAssignedSiteId);

//   const studyData = {
//     totalEnrolments: subjects.length,
//     drafts: subjects.filter((s) => s.progress > 0 && s.progress < 100).length,
//     completed: subjects.filter((s) => s.progress === 100).length,
//   };

//   const checkSubjectLimit = () => {
//     if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   };

//   const checkSiteEnrollmentLimit = (siteId) => {
//     const site = sites.find((s) => s.id === siteId);
//     return !(site && site.enrolled >= site.maxEnrollment);
//   };

//   const addSubject = async (subjectData) => {
//     try {
//       const selectedSite = sites.find(s => s.id === Number(subjectData.siteId));

//       if (!selectedSite) {
//         alert('Selected site not found. Please try again.');
//         return { success: false, error: 'Site not found' };
//       }

//       const studyId = selectedSite.studyId;
//       const userId = selectedSite.userId;

//       if (!studyId) {
//         alert('Study ID not found for selected site.');
//         return { success: false, error: 'Missing study_id' };
//       }

//       if (!userId) {
//         alert('User ID not found for selected site.');
//         return { success: false, error: 'Missing user_id' };
//       }

//       const apiPayload = {
//         user_id: userId,
//         subject_initials: subjectData.subjectInitials.toUpperCase(),
//         study_id: studyId,
//         site_id: Number(subjectData.siteId),
//         enrollment_date: subjectData.enrollmentDate,
//         enrollment_status: subjectData.enrollmentStatus,
//       };

//       console.log('API Payload:', apiPayload);

//       const response = await createSubject(apiPayload);

//       console.log('Create Subject Response:', response);

//       if (response && response.success) {
//         const newSubject = {
//           siteName: subjectData.siteName,
//           siteId: Number(subjectData.siteId),
//           subjectId: response.data?.subject_id || subjectData.subjectId,
//           subjectInitials: subjectData.subjectInitials.toUpperCase(),
//           dateOfEnrollment: convertDateToDisplayFormat(subjectData.enrollmentDate),
//           screeningNumber: response.data?.subject_id || subjectData.subjectId,
//           enrollmentStatus: capitalizeFirstLetter(subjectData.enrollmentStatus),
//           dataCaptureIcon: true,
//           lockStatus: 'unlocked',
//           progress: 0,
//           studyId: studyId,
//         };

//         setSubjects((prev) => [newSubject, ...prev]);
//         alert('Subject created successfully!');
//         return { success: true };
//       } else {
//         throw new Error(response?.message || 'Failed to create subject');
//       }
//     } catch (error) {
//       console.error('Error adding subject:', error);
//       alert(error.message || 'Failed to create subject. Please try again.');
//       return { success: false, error };
//     }
//   };

//   const updateSubject = (subjectId, updatedData) => {
//     setSubjects((prev) =>
//       prev.map((subject) =>
//         subject.subjectId === subjectId
//           ? {
//             ...subject,
//             subjectInitials: updatedData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(updatedData.enrollmentDate),
//             enrollmentStatus: capitalizeFirstLetter(updatedData.enrollmentStatus),
//           }
//           : subject
//       )
//     );
//   };

//   const deleteSubject = (subjectId) => {
//     setSubjects((prev) => prev.filter((s) => s.subjectId !== subjectId));
//   };

//   const toggleSubjectLock = (subjectId) => {
//     setSubjects((prev) =>
//       prev.map((s) =>
//         s.subjectId === subjectId
//           ? {
//             ...s,
//             lockStatus: s.lockStatus === 'locked' ? 'unlocked' : 'locked',
//           }
//           : s
//       )
//     );
//   };

//   return {
//     subjects,
//     sites,
//     loadingSites,
//     loadingSubjects,
//     user,
//     canWrite,
//     canDataCapture,
//     userAssignedSiteId,
//     userSite,
//     userSubjectsCount,
//     studyData,
//     showLimitModal,
//     setShowLimitModal,
//     checkSubjectLimit,
//     checkSiteEnrollmentLimit,
//     addSubject,
//     updateSubject,
//     deleteSubject,
//     toggleSubjectLock,
//     generateSubjectId: (siteCode) => generateSubjectId(siteCode, subjects),
//   };
// };

// import { useState, useEffect } from 'react';
// import {
//   DEFAULT_USER_SITE_ID,
//   MAX_SUBJECTS_PER_USER,
// } from './Contants';
// import {
//   convertDateToDisplayFormat,
//   capitalizeFirstLetter,
//   generateSubjectId,
// } from './utils';
// import { getSitesDropdown, createSubject, getSubjects } from '../../Config/api';

// export const useDataCapture = () => {
//   const [subjects, setSubjects] = useState([]);
//   const [sites, setSites] = useState([]);
//   const [loadingSites, setLoadingSites] = useState(true);
//   const [loadingSubjects, setLoadingSubjects] = useState(true);
//   const [user, setUser] = useState(null);
//   const [userAssignedSiteId, setUserAssignedSiteId] = useState(DEFAULT_USER_SITE_ID);
//   const [showLimitModal, setShowLimitModal] = useState(false);

//   const getToken = () => localStorage.getItem('token');

//   useEffect(() => {
//     const userData = localStorage.getItem('user');
//     if (userData) {
//       const parsedUser = JSON.parse(userData);
//       setUser(parsedUser);
//       if (parsedUser.siteId) {
//         setUserAssignedSiteId(parsedUser.siteId);
//         localStorage.setItem('userAssignedSiteId', parsedUser.siteId.toString());
//       } else {
//         setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//         localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//       }
//     } else {
//       setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
//       localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
//     }
//   }, []);

//   const fetchSubjects = async () => {
//     try {
//       setLoadingSubjects(true);
//       const response = await getSubjects();

//       console.log('Subjects Response:', response);

//       if (response && response.success && response.data) {
//         const formattedSubjects = response.data.map((subject) => {
//           let siteId = null;
//           let studyId = null;

//           if (sites.length > 0) {
//             const matchedSite = sites.find(s =>
//               s.code === subject.site_code ||
//               s.name === subject.site_name
//             );

//             if (matchedSite) {
//               siteId = matchedSite.id;
//               studyId = matchedSite.studyId;
//             }
//           }

//           return {
//             siteName: subject.site_name || subject.siteName,
//             siteCode: subject.site_code || subject.siteCode,
//             siteId: siteId,
//             subjectId: subject.subject_id || subject.subjectId,
//             subjectInitials: subject.subject_initials || subject.subjectInitials,
//             dateOfEnrollment: subject.enrollment_date || subject.dateOfEnrollment,
//             screeningNumber: subject.subject_id || subject.subjectId,
//             enrollmentStatus: capitalizeFirstLetter(subject.enrollment_status || subject.enrollmentStatus),
//             dataCaptureIcon: true,
//             lockStatus: subject.lock_status || 'unlocked',
//             progress: subject.progress || 0,
//             studyId: studyId,
//           };
//         });

//         console.log('Formatted Subjects:', formattedSubjects);
//         setSubjects(formattedSubjects);
//       } else {
//         console.log('No subjects found or invalid response');
//         setSubjects([]);
//       }
//     } catch (error) {
//       console.error('Error fetching subjects:', error);
//       setSubjects([]);
//     } finally {
//       setLoadingSubjects(false);
//     }
//   };

//   const fetchSites = async () => {
//     try {
//       setLoadingSites(true);
//       const data = await getSitesDropdown();

//       console.log('Sites Dropdown Response:', data);

//       if (data.success) {
//         const formattedSites = data.data.map((site) => ({
//           id: site.site_id,
//           code: site.site_code,
//           name: site.site_name,
//           studyId: site.study_id,
//           userId: site.user_id,
//           enrolled: 0,
//           maxEnrollment: site.max_enrollment || 5,
//           progress: 0,
//         }));

//         console.log('Formatted Sites:', formattedSites);
//         setSites(formattedSites);
//       }
//     } catch (error) {
//       console.error('Error fetching sites:', error);
//       setSites([]);
//     } finally {
//       setLoadingSites(false);
//     }
//   };

//   useEffect(() => {
//     fetchSites();
//   }, []);

//   useEffect(() => {
//     if (sites.length > 0) {
//       fetchSubjects();
//     }
//   }, [sites.length]);

//   useEffect(() => {
//     if (sites.length > 0 && subjects.length > 0) {
//       const updatedSites = sites.map((site) => ({
//         ...site,
//         enrolled: subjects.filter((s) => s.siteId === site.id).length,
//         progress: Math.round(
//           (subjects.filter((s) => s.siteId === site.id).length / site.maxEnrollment) * 100
//         ),
//       }));
//       setSites(updatedSites);
//     }
//   }, [subjects]);

//   const userRoleName = user?.role?.roleName;

//   const canWrite = [
//     'CRO Administrator',
//     'Sponsor',
//     'Principal Investigator',
//     'Co-ordinator member',
//   ].includes(userRoleName);

//   const canDataCapture = [
//     'Principal Investigator',
//     'Co-ordinator member',
//   ].includes(userRoleName);

//   const userSubjectsCount = subjects.length;
//   const userSite = sites.find((s) => s.id === userAssignedSiteId);

//   const studyData = {
//     totalEnrolments: subjects.length,
//     drafts: subjects.filter((s) => s.progress > 0 && s.progress < 100).length,
//     completed: subjects.filter((s) => s.progress === 100).length,
//   };

//   const checkSubjectLimit = () => {
//     if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
//       setShowLimitModal(true);
//       return false;
//     }
//     return true;
//   };

//   const checkSiteEnrollmentLimit = (siteId) => {
//     const site = sites.find((s) => s.id === siteId);
//     return !(site && site.enrolled >= site.maxEnrollment);
//   };

//   const addSubject = async (subjectData) => {
//     try {
//       const selectedSite = sites.find(s => s.id === Number(subjectData.siteId));

//       if (!selectedSite) {
//         alert('Selected site not found. Please try again.');
//         return { success: false, error: 'Site not found' };
//       }

//       const studyId = selectedSite.studyId;
//       const userId = selectedSite.userId;

//       console.log('=== ADD SUBJECT DEBUG ===');
//       console.log('Selected Site:', selectedSite);
//       console.log('Study ID:', studyId);
//       console.log('User ID:', userId);
//       console.log('========================');

//       if (!studyId) {
//         alert('Study ID not found for selected site.');
//         return { success: false, error: 'Missing study_id' };
//       }

//       if (!userId) {
//         alert('User ID not found for selected site.');
//         return { success: false, error: 'Missing user_id' };
//       }

//       const apiPayload = {
//         user_id: userId,
//         subject_initials: subjectData.subjectInitials.toUpperCase(),
//         study_id: studyId,
//         site_id: Number(subjectData.siteId),
//         enrollment_date: subjectData.enrollmentDate,
//         enrollment_status: subjectData.enrollmentStatus,
//       };

//       console.log('API Payload:', apiPayload);

//       const response = await createSubject(apiPayload);

//       console.log('Create Subject Response:', response);

//       if (response && response.success) {
//         const newSubject = {
//           siteName: subjectData.siteName,
//           siteId: Number(subjectData.siteId),
//           subjectId: response.data?.subject_id || subjectData.subjectId,
//           subjectInitials: subjectData.subjectInitials.toUpperCase(),
//           dateOfEnrollment: convertDateToDisplayFormat(subjectData.enrollmentDate),
//           screeningNumber: response.data?.subject_id || subjectData.subjectId,
//           enrollmentStatus: capitalizeFirstLetter(subjectData.enrollmentStatus),
//           dataCaptureIcon: true,
//           lockStatus: 'unlocked',
//           progress: 0,
//           studyId: studyId,
//         };

//         setSubjects((prev) => [newSubject, ...prev]);
//         alert('Subject created successfully!');

//         // Return the response data so we can use it for navigation
//         return {
//           success: true,
//           data: response.data
//         };
//       } else {
//         throw new Error(response?.message || 'Failed to create subject');
//       }
//     } catch (error) {
//       console.error('Error adding subject:', error);
//       alert(error.message || 'Failed to create subject. Please try again.');
//       return { success: false, error };
//     }
//   };

//   const updateSubject = (subjectId, updatedData) => {
//     setSubjects((prev) =>
//       prev.map((subject) =>
//         subject.subjectId === subjectId
//           ? {
//             ...subject,
//             subjectInitials: updatedData.subjectInitials.toUpperCase(),
//             dateOfEnrollment: convertDateToDisplayFormat(updatedData.enrollmentDate),
//             enrollmentStatus: capitalizeFirstLetter(updatedData.enrollmentStatus),
//           }
//           : subject
//       )
//     );
//   };

//   const deleteSubject = (subjectId) => {
//     setSubjects((prev) => prev.filter((s) => s.subjectId !== subjectId));
//   };

//   const toggleSubjectLock = (subjectId) => {
//     setSubjects((prev) =>
//       prev.map((s) =>
//         s.subjectId === subjectId
//           ? {
//             ...s,
//             lockStatus: s.lockStatus === 'locked' ? 'unlocked' : 'locked',
//           }
//           : s
//       )
//     );
//   };

//   return {
//     subjects,
//     sites,
//     loadingSites,
//     loadingSubjects,
//     user,
//     canWrite,
//     canDataCapture,
//     userAssignedSiteId,
//     userSite,
//     userSubjectsCount,
//     studyData,
//     showLimitModal,
//     setShowLimitModal,
//     checkSubjectLimit,
//     checkSiteEnrollmentLimit,
//     addSubject,
//     updateSubject,
//     deleteSubject,
//     toggleSubjectLock,
//     generateSubjectId: (siteCode) => generateSubjectId(siteCode, subjects),
//   };
// };

import { useState, useEffect } from 'react';
import {
  DEFAULT_USER_SITE_ID,
  MAX_SUBJECTS_PER_USER,
} from './Contants';
import {
  convertDateToDisplayFormat,
  capitalizeFirstLetter,
  generateSubjectId,
} from './utils';
import { getSitesDropdown, createSubject, getSubjects } from '../../Config/api';

export const useDataCapture = () => {
  const [subjects, setSubjects] = useState([]);
  const [sites, setSites] = useState([]);
  const [loadingSites, setLoadingSites] = useState(true);
  const [loadingSubjects, setLoadingSubjects] = useState(true);
  const [user, setUser] = useState(null);
  const [userAssignedSiteId, setUserAssignedSiteId] = useState(DEFAULT_USER_SITE_ID);
  const [showLimitModal, setShowLimitModal] = useState(false);

  const getToken = () => localStorage.getItem('token');

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);
      if (parsedUser.site.siteId) {
        setUserAssignedSiteId(parsedUser.site.siteId);
        localStorage.setItem('userAssignedSiteId', parsedUser.site.siteId.toString());
      } else {
        setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
        localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
      }
    } else {
      setUserAssignedSiteId(DEFAULT_USER_SITE_ID);
      localStorage.setItem('userAssignedSiteId', DEFAULT_USER_SITE_ID.toString());
    }
  }, []);

  const fetchSubjects = async () => {
    try {
      setLoadingSubjects(true);
      const response = await getSubjects();

      console.log('Subjects Response:', response);

      if (response && response.success && response.data) {
        // const formattedSubjects = response.data.map((subject) => {
        //   let siteId = null;
        //   let studyId = null;

        //   if (sites.length > 0) {
        //     const matchedSite = sites.find(s =>
        //       s.code === subject.site_code ||
        //       s.name === subject.site_name
        //     );

        //     if (matchedSite) {
        //       siteId = matchedSite.id;
        //       studyId = matchedSite.studyId;
        //     }
        //   }

        //   return {
        //     siteName: subject.site_name || subject.siteName,
        //     siteCode: subject.site_code || subject.siteCode,
        //     siteId: siteId,
        //     subjectId: subject.subject_id || subject.subjectId,
        //     subjectInitials: subject.subject_initials || subject.subjectInitials,
        //     dateOfEnrollment: subject.enrollment_date || subject.dateOfEnrollment,
        //     screeningNumber: subject.subject_id || subject.subjectId,
        //     enrollmentStatus: capitalizeFirstLetter(subject.enrollment_status || subject.enrollmentStatus),
        //     dataCaptureIcon: true,
        //     lockStatus: subject.lock_status || 'unlocked',
        //     progress: subject.progress || 0,
        //     studyId: studyId,
        //   };
        // });
        const formattedSubjects = response.data.map((subject) => {
          console.log('Processing Subject:', subject);
          let siteId = subject.site_id;
          let studyId = subject.study_id;

          if (sites.length > 0) {
            const matchedSite = sites.find(
              s => s.id === subject.site_id
            );

            if (matchedSite) {
              siteId = matchedSite.id;
              studyId = matchedSite.studyId;
            }
          }

          return {
            siteName: subject.site_name,
            siteCode: subject.site_code,
            siteId: siteId,
            subjectId: subject.subject_id,
            subjectInitials: subject.subject_initials,
            dateOfEnrollment: subject.enrollment_date,
            screeningNumber: subject.subject_id,
            enrollmentStatus: capitalizeFirstLetter(subject.enrollment_status),
            dataCaptureIcon: true,
            lockStatus: subject.lock_status || 'unlocked',
            progress: subject.progress || 0,
            studyId: subject.study_id,
          };
        });

        console.log('Formatted Subjects:', formattedSubjects);
        setSubjects(formattedSubjects);
      } else {
        console.log('No subjects found or invalid response');
        setSubjects([]);
      }
    } catch (error) {
      console.error('Error fetching subjects:', error);
      setSubjects([]);
    } finally {
      setLoadingSubjects(false);
    }
  };

  const fetchSites = async () => {
    try {
      setLoadingSites(true);
      const data = await getSitesDropdown();

      console.log('Sites Dropdown Response:', data);

      if (data.success) {
        const formattedSites = data.data.map((site) => ({
          id: site.site_id,
          code: site.site_code,
          name: site.site_name,
          studyId: site.study_id,
          userId: site.user_id,
          enrolled: 0,
          maxEnrollment: site.max_enrollment || 5,
          progress: 0,
        }));

        console.log('Formatted Sites:', formattedSites);
        setSites(formattedSites);
      }
    } catch (error) {
      console.error('Error fetching sites:', error);
      setSites([]);
    } finally {
      setLoadingSites(false);
    }
  };

  useEffect(() => {
    fetchSites();
  }, []);

  useEffect(() => {
    if (sites.length > 0) {
      fetchSubjects();
    }
  }, [sites.length]);

  useEffect(() => {
    if (sites.length > 0 && subjects.length > 0) {
      const updatedSites = sites.map((site) => ({
        ...site,
        enrolled: subjects.filter((s) => s.siteId === site.id).length,
        progress: Math.round(
          (subjects.filter((s) => s.siteId === site.id).length / site.maxEnrollment) * 100
        ),
      }));
      setSites(updatedSites);
    }
  }, [subjects]);

  const userRoleName = user?.role?.roleName;

  const canWrite = [
    'CRO Administrator',
    'Sponsor',
    'Principal Investigator',
    'Co-ordinator member',
  ].includes(userRoleName);

  const canDataCapture = [
    'Principal Investigator',
    'Co-ordinator member',
  ].includes(userRoleName);

  const userSubjectsCount = subjects.length;
  const userSite = sites.find((s) => s.id === userAssignedSiteId);

  const studyData = {
    totalEnrolments: subjects.length,
    drafts: subjects.filter((s) => s.progress > 0 && s.progress < 100).length,
    completed: subjects.filter((s) => s.progress === 100).length,
  };

  const checkSubjectLimit = () => {
    if (userSubjectsCount >= MAX_SUBJECTS_PER_USER) {
      setShowLimitModal(true);
      return false;
    }
    return true;
  };

  const checkSiteEnrollmentLimit = (siteId) => {
    const site = sites.find((s) => s.id === siteId);
    return !(site && site.enrolled >= site.maxEnrollment);
  };

  const addSubject = async (subjectData) => {
    try {
      const selectedSite = sites.find(s => s.id === Number(subjectData.siteId));

      if (!selectedSite) {
        alert('Selected site not found. Please try again.');
        return { success: false, error: 'Site not found' };
      }

      const studyId = subjectData.studyId;
      const userId = subjectData.userId;

      console.log('=== ADD SUBJECT DEBUG ===');
      console.log('Subject Data:', subjectData);
      console.log('Selected Site:', selectedSite);
      console.log('Study ID from formData:', studyId);
      console.log('User ID from formData:', userId);
      console.log('========================');

      if (!studyId) {
        alert('Study ID not found. Please try again.');
        return { success: false, error: 'Missing study_id' };
      }

      if (!userId) {
        alert('User ID not found. Please try again.');
        return { success: false, error: 'Missing user_id' };
      }

      const apiPayload = {
        user_id: userId,
        subject_initials: subjectData.subjectInitials.toUpperCase(),
        study_id: studyId,
        site_id: Number(subjectData.siteId),
        enrollment_date: subjectData.enrollmentDate,
        enrollment_status: subjectData.enrollmentStatus,
      };

      console.log('API Payload:', apiPayload);

      const response = await createSubject(apiPayload);

      console.log('Create Subject Response:', response);

      if (response && response.success) {
        const newSubject = {
          siteName: subjectData.siteName,
          siteId: Number(subjectData.siteId),
          subjectId: response.data?.subject_id || subjectData.subjectId,
          subjectInitials: subjectData.subjectInitials.toUpperCase(),
          dateOfEnrollment: convertDateToDisplayFormat(subjectData.enrollmentDate),
          screeningNumber: response.data?.subject_id || subjectData.subjectId,
          enrollmentStatus: capitalizeFirstLetter(subjectData.enrollmentStatus),
          dataCaptureIcon: true,
          lockStatus: 'unlocked',
          progress: 0,
          studyId: studyId,
        };

        setSubjects((prev) => [newSubject, ...prev]);
        alert('Subject created successfully!');

        return {
          success: true,
          data: response.data
        };
      } else {
        throw new Error(response?.message || 'Failed to create subject');
      }
    } catch (error) {
      console.error('Error adding subject:', error);
      alert(error.message || 'Failed to create subject. Please try again.');
      return { success: false, error };
    }
  };

  const updateSubject = (subjectId, updatedData) => {
    setSubjects((prev) =>
      prev.map((subject) =>
        subject.subjectId === subjectId
          ? {
            ...subject,
            subjectInitials: updatedData.subjectInitials.toUpperCase(),
            dateOfEnrollment: convertDateToDisplayFormat(updatedData.enrollmentDate),
            enrollmentStatus: capitalizeFirstLetter(updatedData.enrollmentStatus),
          }
          : subject
      )
    );
  };

  const deleteSubject = (subjectId) => {
    setSubjects((prev) => prev.filter((s) => s.subjectId !== subjectId));
  };

  const toggleSubjectLock = (subjectId) => {
    setSubjects((prev) =>
      prev.map((s) =>
        s.subjectId === subjectId
          ? {
            ...s,
            lockStatus: s.lockStatus === 'locked' ? 'unlocked' : 'locked',
          }
          : s
      )
    );
  };

  return {
    subjects,
    sites,
    loadingSites,
    loadingSubjects,
    user,
    canWrite,
    canDataCapture,
    userAssignedSiteId,
    userSite,
    userSubjectsCount,
    studyData,
    showLimitModal,
    setShowLimitModal,
    checkSubjectLimit,
    checkSiteEnrollmentLimit,
    addSubject,
    updateSubject,
    deleteSubject,
    toggleSubjectLock,
    generateSubjectId: (siteCode) => generateSubjectId(siteCode, subjects),
  };
};